import moment from "moment";
import { Link } from "react-router-dom";

function buildPercent(made, attempted, percent) {
    if (percent !== undefined && percent !== null) return `${percent}%`;
    if (!attempted) return "0%";
    return `${Math.round((made / attempted) * 100)}%`;
}

export default function JugadorGameLogSection({
    selectedLeague,
    isLoading,
    gameLog = [],
    onClose,
    isCollapsed = false,
    onToggleCollapse,
}) {
    if (!selectedLeague) {
        return null;
    }

    return (
        <section className="mb-12">
            <div className={`flex items-center justify-between gap-3 border border-white/10 bg-[#102216] px-4 py-1.5 ${isCollapsed ? "rounded-lg" : "rounded-t-lg"}`}>
                <h3 className="text-base md:text-lg font-bold text-slate-200">Partidos - {selectedLeague}</h3>
                <div className="flex items-center gap-3">
                    <button
                        type="button"
                        onClick={onToggleCollapse}
                        className="text-xs font-semibold uppercase tracking-wide text-slate-300 transition-colors hover:text-green-400"
                    >
                        {isCollapsed ? "Mostrar" : "Ocultar"}
                    </button>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-sm font-semibold text-red-400 transition-colors hover:text-red-300 hover:underline"
                    >
                        Cerrar
                    </button>
                </div>
            </div>

            <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${isCollapsed ? "grid-rows-[0fr] opacity-0" : "grid-rows-[1fr] opacity-100"}`}>
                <div className="min-h-0 overflow-hidden">
                    <div className="-mt-px max-h-[70vh] overflow-auto rounded-b-xl border-x border-b border-white/10 bg-[#102216] relative">
                        {isLoading ? (
                            <div className="p-6 text-center text-slate-300 text-base">Cargando partidos...</div>
                        ) : (
                            <>
                            <p className="sm:hidden h-5 flex items-center justify-end text-[10px] text-slate-500 px-3 sticky top-0 left-0 z-20 w-full pointer-events-none bg-[#102216]">Desliza para ver más →</p>
                            <table className="table-auto w-max min-w-full text-left text-xs sm:text-sm">
                        <thead className="sticky top-5 sm:top-0 z-10">
                            <tr className="bg-[#102216] text-xs md:text-sm font-bold uppercase tracking-wider text-slate-500 border-b border-white/10">
                                <th className="px-3 py-3">Adversario</th>
                                <th className="px-3 py-3 text-center">Fecha</th>
                                <th className="px-2 py-3 text-center">MIN</th>
                                <th className="px-2 py-3 text-center">PTS</th>
                                <th className="px-2 py-3 text-center">2PT</th>
                                <th className="px-2 py-3 text-center">2PT%</th>
                                <th className="px-2 py-3 text-center">3PT</th>
                                <th className="px-2 py-3 text-center">3PT%</th>
                                <th className="px-2 py-3 text-center">1PTS</th>
                                <th className="px-2 py-3 text-center">1PTS%</th>
                                <th className="px-2 py-3 text-center">RO</th>
                                <th className="px-2 py-3 text-center">RD</th>
                                <th className="px-2 py-3 text-center">RT</th>
                                <th className="px-2 py-3 text-center">AST</th>
                                <th className="px-2 py-3 text-center">PER</th>
                                <th className="px-2 py-3 text-center">ROB</th>
                                <th className="px-2 py-3 text-center">BLQ</th>
                                <th className="px-2 py-3 text-center">FP</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-white/10 text-slate-300">
                            {gameLog.map((game) => {
                                const stats = game?.jugador?.[0] || {};

                                return (
                                    <tr key={`game-${game._id}-${game.fecha}`} className="hover:bg-white/5 transition-colors">
                                        <td className="px-3 py-2.5 font-medium text-green-400">
                                            {game._id ? (
                                                <Link to={`/partido/${game._id}`} className="hover:underline">
                                                    {game.adversario || "-"}
                                                </Link>
                                            ) : (
                                                game.adversario || "-"
                                            )}
                                        </td>
                                        <td className="px-3 py-2.5 text-center">{game.fecha ? moment(game.fecha).format("DD/MM/YYYY") : "-"}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.minutos ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.puntos ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.doblesHechos ?? 0}/{stats.doblesIntent ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{buildPercent(stats.doblesHechos ?? 0, stats.doblesIntent ?? 0, stats.doblesPercent)}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.triplesHechos ?? 0}/{stats.triplesIntent ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{buildPercent(stats.triplesHechos ?? 0, stats.triplesIntent ?? 0, stats.triplesPercent)}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.libresHechos ?? 0}/{stats.libresIntent ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{buildPercent(stats.libresHechos ?? 0, stats.libresIntent ?? 0, stats.libresPercent)}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.rebotesOf ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.rebotesDef ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.rebotesTot ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.asistencias ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.perdidas ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.robos ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.tapas ?? 0}</td>
                                        <td className="px-2 py-2.5 text-center">{stats.fouls ?? 0}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                            </table>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
